/**
 * Returns true on a desktop browser session — Platform.OS === 'web' AND a
 * fine pointer (mouse/trackpad). Used to flip "Take photo" affordances
 * over to "Upload" copy + icon, because expo-image-picker's
 * launchCameraAsync on desktop browsers silently degrades to a file
 * picker (no real environment-facing camera), which makes "tap to take a
 * photo" misleading.
 *
 * Mobile web stays on the camera-style copy because launchCameraAsync
 * there opens the device camera capture intent.
 */
import { useEffect, useState } from 'react'
import { Platform } from 'react-native'

function compute(): boolean {
  if (Platform.OS !== 'web') return false
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia('(pointer: fine)').matches
}

export function useIsDesktopWeb(): boolean {
  const [isDesktopWeb, setIsDesktopWeb] = useState(compute)

  useEffect(() => {
    if (Platform.OS !== 'web') return
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia('(pointer: fine)')
    const onChange = () => setIsDesktopWeb(mq.matches)
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange)
      return () => mq.removeEventListener('change', onChange)
    }
    mq.addListener(onChange)
    return () => mq.removeListener(onChange)
  }, [])

  return isDesktopWeb
}
